import { selectFeatureFlags } from 'core/userContext';
import { useProjectUsage } from 'modules/billing/hooks/useProjectUsage';
import { useSelector } from 'react-redux';
import { CATALOG_METRICS } from '../../constants';
import { queryByFn } from '../../utils';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import { ProjectUsagePageActions } from './ProjectUsagePageActions';
import { createRowCell } from './TableCell';

export const CATALOG_PROJECT_USAGE_TEXT = {
  pageTitle: 'Catalog usage',
};

export const CatalogProjectUsage = () => {
  const { ProductRecommendations } = useSelector(selectFeatureFlags);
  const metricNames = [
    CATALOG_METRICS.catalogLookup,
    CATALOG_METRICS.catalogCollection,
    ...(ProductRecommendations ? [CATALOG_METRICS.productRecommendation] : []),
  ];

  const { breadcrumb, columns, isLoading, rows } = useProjectUsage(metricNames);

  return (
    <SimpleIndexPage
      breadcrumb={breadcrumb}
      columns={columns}
      createRowCell={createRowCell}
      isLoading={isLoading}
      pageActions={<ProjectUsagePageActions />}
      pageTitle={CATALOG_PROJECT_USAGE_TEXT.pageTitle}
      queryByFn={queryByFn}
      rows={rows}
    />
  );
};
